// extracted by mini-css-extract-plugin
export default {"SchemaHeader":"ViewPaymentsDepositDetails_SchemaHeader__dl9+w","SchemaBody":"ViewPaymentsDepositDetails_SchemaBody__pUCWZ"};